import React,{useEffect, useState,useRef} from "react";
import { useSelector,useDispatch } from 'react-redux'
import Layout from "../components/Layout";
import UserRoleForm from './forms/roleNameForm';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import {fetchuserRole} from '../redux/features/roleName.feature'
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { BASE_URL } from '../utils/commonUrl';
import axios from 'axios';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const UserRole = () => {
    const dispatch = useDispatch();
    const {user} = useSelector(state => state['auth']);
    const primeToast = useRef(null)
    const state = useSelector((state) => { return state["userRole"] })
    const [start] = useState(0);
    const [modal, setModal] = useState(false)
    const [userRoleItem, setUserRoleItem] = useState({ roleName: '', active: true, userRoleID: 0 })

    useEffect(() => {
        initFilters1();
        dispatch(fetchuserRole())

    }, [])
    const onSubmit = async data => {
        try {
            const url = BASE_URL + "/api/userRole";
            //data.addedBy = user.registerID
            //data.updatedBy = user.registerID
            //data.updatedBy = user.registerID
            const response = await axios.post(url, data);
            if (response.status === 200) {
                primeToast.current.show({ severity: 'success', summary: 'success', detail: 'Role Name Save successfully', life: 3000 });
                setUserRoleItem({ roleName: '', active: true, userRoleID: 0 });
                setModal(!modal)
                dispatch(fetchuserRole())
            }
        } catch (e) {
            console.log(e)
            primeToast.current.show({ severity: 'error', summary: 'error', detail: 'An Error ', life: 3000 });
        }

    }

    const onFormHide = () => {
        setUserRoleItem({ roleName: '', active: true, userRoleID: 0 });
        setModal(!modal)
    }

    const editGridData = data => {
        setUserRoleItem({ roleName: data.roleName, active: data.active, userRoleID: data.userRoleID });      
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteQuarterItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }


    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }


    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'quarterName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'yearNo': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end




    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editGridData(rowData)} />
             &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => deleteGridData(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1}
                               placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Role Name</button>
            </div>
        </div>
    );
    const footer = `In total there are ${state.userRole ? state.userRole.length : 0} roleName.`;
    const _isActiveColumn = (rowData) =>{
        return <div>{rowData.active ? <>Active</>:<>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={state.userRole} header={header}
                   showGridlines
                   dataKey="userRoleID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['roleName', 'active']}
                   //footer={footer}
                   paginator rows={7} first={start}
            paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="userRoleID" header="User RoleD ID" hidden={true}/>
            <Column field='roleName' header="Role Type" />
            <Column field='active' header="Active" body={_isActiveColumn} />
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem'}}/>
        </DataTable>
    )

    return (
        <Layout>
            <Toast ref={primeToast}/>
            <UserRoleForm
                modal={modal}
                active={true}
                userRoleID={userRoleItem.userRoleID}
                roleName={userRoleItem.roleName}
                onSubmit={onSubmit}
                onHide={onFormHide} />
                {Table}
        </Layout>
    );
};

export default UserRole;